import React from "react";
import PropTypes from "prop-types";
import { StatusPill, formatDate } from "@ufginsurance/ui-kit";
import { Translations } from "../../translations";
import { formatCurrencyUSD } from "../../../surety/shared/utils";
import "./QuoteInfo.scss";

const QuoteInfo = ({ result }) => {
  const { quoteList } = Translations.commercial.new_submissions_tab;
  const searchStatus =
    Translations.commercial.new_submissions_tab.status_options.find(
      x => x.value === result.status
    );
  const statusName = searchStatus?.label || result.status;
  const statusColor = searchStatus?.color || "green";

  return (
    <>
      <div key="list" className="col-md-6 expanded-quotes-list">
        <div className="quote-info-item">
          <dt>{quoteList.quote_number}:</dt>
          <dd>
            <span className="quote_number">{result.quote_number}</span>
          </dd>
        </div>
        <div className="quote-info-item">
          <dt>{quoteList.product}:</dt>
          <dd>
            <span className="product">{result.product}</span>
          </dd>
        </div>
        <div className="quote-info-item">
          <dt>{quoteList.effective_date}:</dt>
          <dd>
            <span
              className={`${
                result.is_effective_date_expired ? "effective-date-expired" : ""
              }`}
            >
              {formatDate(result.effective_date, "MM/DD/YYYY")}
            </span>
            {result.is_effective_date_expired &&
              !!result.effective_date_expired_url && (
                <span>
                  {` - `}
                  <a
                    rel="noopener noreferrer"
                    href={result.effective_date_expired_url}
                  >
                    Edit
                  </a>
                </span>
              )}
          </dd>
        </div>
        <div className="quote-info-item">
          <dt>{quoteList.status_last_updated}:</dt>
          <dd>
            <span className="status_last_updated">
              {formatDate(result?.status_last_updated, "MM/DD/YYYY")}
            </span>
          </dd>
        </div>
        <div className="quote-info-item">
          <dt>{quoteList.status}:</dt>
          <dd className="statusDeclined">
            <span>
              {/* 'NotTaken' is the only progress that needs space currently */}
              {result.progress === "NotTaken" ? "Not Taken" : result.progress}
            </span>
            <StatusPill
              text={statusName}
              color={statusColor}
              className="searchStatusPill"
            />
          </dd>
        </div>
        <div className="quote-info-item">
          <dt>{quoteList.premium_amount}:</dt>
          <dd>
            <span className="premium_amount">
              {result.premium_amount === 0 &&
              result.core_system === "BuildersRisk" ? (
                <span>-</span>
              ) : (
                <span>
                  {formatCurrencyUSD(
                    result.premium_amount,
                    result.core_system === "BuildersRisk" ? 0 : 2
                  )}
                </span>
              )}
            </span>
          </dd>
        </div>
        {result.policy_number && (
          <div className="quote-info-item">
            <dt>{quoteList.policy_number}:</dt>
            <dd>
              <span className="policy_number">{result.policy_number}</span>
            </dd>
          </div>
        )}
      </div>
    </>
  );
};

QuoteInfo.propTypes = {
  result: PropTypes.object
};

export default QuoteInfo;
